import AppData from './appdata.es6';
import Screen from './screen.es6';

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.getUA();
        this.pageIn();
        window.QUERY = this.getQuery();
        window.DATA = new AppData();
        this.screen = new Screen();

        //for debug
        //this.addResetBtn();
    }

    getUA() {
        //UA付与
        const ua = navigator.userAgent;
        const bodyClass = document.body.classList;

        if (ua.indexOf('iPhone') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
            // mobile
            bodyClass.add('mobile');
        } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
            // tablet
            bodyClass.add('tablet');
        } else {
            // desktop
            bodyClass.add('desktop');
        }
    }

    getQuery() {
        let vars = {};
        const param = location.search.substring(1).split('&');
        for (let i = 0; i < param.length; i++) {
            let keySearch = param[i].search(/=/);
            let key = '';
            if (keySearch != -1) key = param[i].slice(0, keySearch);
            let val = param[i].slice(param[i].indexOf('=', 0) + 1);
            if (key != '') vars[key] = decodeURI(val);
        }
        return vars;
    }

    addResetBtn() {
        const elm = document.createElement('div');
        elm.textContent = 'Reset';
        elm.classList.add('c-reset');
        document.getElementsByTagName('body')[0].appendChild(elm);

        elm.addEventListener('click', () => {
            location.href = './';
        });
    }

    pageIn() {
        //bodyのフェードイン
        $('.c-main').addClass('-ready');
    }
}
